/* 選んで、その場でカートへ（2026-10-02）。snippets/kz-buy のフォーム（data-kz-buy）に動きをつける。
   ・食数・味を選ぶと、価格（と1食あたり）がめくれて変わる。選択肢が2段の商品（味×容量）は組み合わせから選ぶ。
   ・「カートに入れる」で cart/add.js に送り、既存の引き出しカートを cart:change で開く（kazu-cart-extras と同じ形）。
     入ったかどうか確かでないときは、二重に入れないようカートのページへ。JSが無いときは普通のフォームとして送られる。 */
(() => {
  const root = document.documentElement;
  const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const cartIsPage = () => window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.cartType === 'page';
  const timeout = (ms) => (window.AbortSignal && AbortSignal.timeout ? AbortSignal.timeout(ms) : undefined);

  const init = (form) => {
    if (form.dataset.kzReady) return;
    form.dataset.kzReady = '1';
    const price = form.querySelector('[data-kz-price]');
    const per = form.querySelector('[data-kz-per]');
    const btn = form.querySelector('[data-kz-add]');
    const label = btn && btn.querySelector('.kz-buy__label');
    const status = form.querySelector('.kz-buy__status');
    const idle = label ? label.textContent : '';
    const flip = (txt, anim) => {
      if (!price || !txt || price.textContent === txt) return;
      price.textContent = txt;
      if (anim) { price.classList.remove('is-flip'); void price.offsetWidth; price.classList.add('is-flip'); }
    };
    const vj = form.querySelector('[data-kz-variants]');
    const variants = vj ? JSON.parse(vj.textContent) : null;
    const sync = (anim) => {
      if (variants) {
        const picked = [...form.querySelectorAll('[data-kz-opt]')].map((fs) => { const c = fs.querySelector('input:checked'); return c ? c.value : null; });
        const v = variants.find((x) => x.o.every((o, i) => o === picked[i]));
        const hid = form.querySelector('input[type="hidden"][name="id"]');
        if (v && hid) hid.value = v.id;
        if (v) flip(v.p, anim);
        if (btn) btn.disabled = !v || !v.a;
        if (status) status.textContent = v ? (v.a ? '' : 'この組み合わせは、ただいま品切れです') : 'この組み合わせはありません';
        form.querySelectorAll('[data-kz-opt]').forEach((fs) => {
          const oi = Number(fs.dataset.kzOpt);
          fs.querySelectorAll('input').forEach((inp) => {
            const ok = variants.some((x) => x.a && x.o[oi] === inp.value && x.o.every((o, i) => i === oi || o === picked[i]));
            inp.closest('.kz-chip').classList.toggle('is-off', !ok);
          });
        });
        return;
      }
      /* 数（セット数）を選べるとき：価格は「数 × 1つの価格」（data-price に入っている） */
      const q = form.querySelector('input[name="quantity"]:checked');
      if (q && q.dataset.price) { flip(q.dataset.price, anim); return; }
      const r = form.querySelector('input[name="id"]:checked');
      if (!r) return;
      flip(r.dataset.price, anim);
      if (per) per.textContent = r.dataset.per ? `1食あたり 約${r.dataset.per}円` : '';
      if (btn) btn.disabled = r.disabled;
    };
    form.addEventListener('change', () => sync(true));
    sync(false);

    form.addEventListener('submit', async (e) => {
      if (!window.fetch || !btn) return;
      e.preventDefault();
      if (btn.getAttribute('aria-busy') === 'true') return;
      const id = Number(new FormData(form).get('id'));
      if (!id) return;
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('is-busy');
      if (status) status.textContent = 'カートに入れています…';
      let accepted = false;
      let definite = false;
      try {
        const sections = [];
        root.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
        const res = await fetch(base + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id, quantity: Math.max(1, Number(new FormData(form).get('quantity')) || 1) }], sections: [...new Set(sections)].slice(0, 5), sections_url: location.pathname }),
          signal: timeout(20000)
        });
        const result = await res.json();
        if (!res.ok) { definite = res.status >= 400 && res.status < 500; throw new Error(result.description || 'カートに入れられませんでした'); }
        accepted = true;
        if (cartIsPage()) { location.assign(base + 'cart'); return; }
        const cr = await fetch(base + 'cart.js', { credentials: 'same-origin', cache: 'no-store', signal: timeout(12000) });
        if (!cr.ok) throw new Error('cart-refresh');
        const cart = await cr.json();
        if (sections.some((s) => !(result.sections && result.sections[s]))) throw new Error('section-refresh');
        cart.sections = result.sections || {};
        root.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart } }));
        btn.classList.add('is-done');
        if (label) label.textContent = 'カートに入れました';
        if (status) status.textContent = '';
        setTimeout(() => { btn.classList.remove('is-done'); if (label) label.textContent = idle; }, 2200);
      } catch (err) {
        if (accepted || !definite) {
          if (status) status.textContent = '入ったかを確かめるため、カートを開きます';
          location.assign(base + 'cart');
        } else if (status) {
          status.textContent = err.message;
        }
      } finally {
        btn.removeAttribute('aria-busy');
        btn.classList.remove('is-busy');
      }
    });
  };
  const run = () => document.querySelectorAll('[data-kz-buy]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
